<template>
    <Multiselect
        :model-value="modelValue"
        @update:modelValue="updateValue"
        :options="options"
        :multiple="multiple"
        :close-on-select="!multiple"
        :clear-on-select="false"
        :preserve-search="true"
        placeholder="Seleccione una opción"
        label="label"
        trackBy="value"
    />
    <!--
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :label="label"
        :track-by="trackBy"
    -->
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
    components: {
        Multiselect
    },

    props: {
        modelValue: {
            default: null
        },

        options: {
            type: Array,
            default: () => []
        },

        multiple: {
            type: Boolean,
            default: false
        },

        label: {
            type: String,
            default: 'name'
        },

        trackBy: {
            type: String,
            default: 'id'
        }
    },

    emits: ['update:modelValue'],

    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value)
        }
    }
}
</script>